import React, { useState, useEffect } from 'react'
import {
  IconButton,
  Icon,
  Panel,
  ControlLabel,
  FormGroup,
  Grid,
  Form,
  Row,
  Col,
  SelectPicker,
  Message,
  Input,
} from 'rsuite'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { isRequired, isValidators, isRequiredFiled } from '../../../utils/ValidatorUtils'
import ProjectManageStructureTableForm from './ProjectManageStructureTableForm'
import ProjectManageAttachWidget from './ProjectManageAttachWidget'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import CustomNote from '../../CustomNote'

export default function ProjectManageStructureForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { isDeleteError, isError, loading, onDownload, onPreview } = props

  // const [schema, setSchema] = useState(mock)
  const [roleName, setRoleName] = useState()
  const [otherRoleName, setOtherRoleName] = useState()
  const [honorific, setHonorific] = useState()
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()
  const [email, setEmail] = useState()
  const [telephone, setTelephone] = useState()
  const [editIndex, setEditIndex] = useState(-1)
  const [section, setSection] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)

  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    // let schema = _schema
    //console.log('ProjectManageStructureForm _schema', _schema)
    setSchema(_schema)
    setIsAdd(isError)
    setEditIndex(-1)
    setValue('selectedIndex', -1)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setRoleName('')
    setOtherRoleName('')
    setHonorific('')
    setFirstName('')
    setLastName('')
    setEmail('')
    setTelephone('')

    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditIndex(-1)
    setValue('selectedIndex', -1)
  }
  const handleEdit = (data, index) => {
    // let data = dataList[index]
    console.log('index', index, 'data', data, 'schema', schema)

    setRoleName(data.roleCode)
    setOtherRoleName(data.otherRoleName)
    setHonorific(data.honorificCode)
    setFirstName(data.firstName)
    setLastName(data.lastName)
    setEmail(data.email)
    setTelephone(data.telephone)

    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditIndex(index)
    setValue('selectedIndex', index)
    setValue(schema.role.otherRoleName.name, data.otherRoleName)
    setValue(schema.role.firstName.name, data.firstName)
    setValue(schema.role.lastName.name, data.lastName)
    setValue(schema.role.email.name, data.email)
    setValue(schema.role.telephone.name, data.telephone)

    setValue(schema.role.roleName.name, data.roleCode)
    setValue(schema.role.honorific.name, data.honorificCode)
  }

  const AddForm = () => {
    return (
      <Grid fluid style={{ marginTop: 10 }}>
        <Form fluid>
          <FormGroup>
            <Controller
              key={'selectedIndex'}
              name={'selectedIndex'}
              control={control}
              defaultValue={editIndex}
            />
            <Row>
              <Col xs={24} sm={24} md={10} lg={10}>
                <ErrorMessage error={errors[schema.role.roleName.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.roleName.validators),
                    schema.role.roleName.label
                  )}
                </ControlLabel>
                <Controller
                  key={schema.role.roleName.name}
                  name={schema.role.roleName.name}
                  control={control}
                  rules={isValidators(schema.role.roleName.validators)}
                  defaultValue={roleName}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ width: '100%' }}
                        searchable={false}
                        value={props.value}
                        data={schema.roleOptions?.filter((e) => e.value != '1')}
                        placeholder={schema.role.roleName.hint}
                        onChange={(value) => {
                          setRoleName(value)
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              {roleName == '6' && (
                <Col xs={24} sm={24} md={10} lg={10}>
                  <ErrorMessage error={errors[schema.role.otherRoleName.name]} />
                  <ControlLabel>
                    {isRequiredFiled(
                      isRequired(schema.role.otherRoleName.validators),
                      schema.role.otherRoleName.label
                    )}
                  </ControlLabel>
                  <Input
                    name={schema.role.otherRoleName.name}
                    // defaultValue={schema.role.otherRoleName.value}
                    defaultValue={otherRoleName}
                    placeholder={
                      schema.role.otherRoleName.hint || `ระบุ${schema.role.otherRoleName.label}`
                    }
                    inputRef={register(isValidators(schema.role.otherRoleName.validators))}
                    onChange={(value) => setOtherRoleName(value)}
                  />
                </Col>
              )}
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={4} md={4} lg={4}>
                <ErrorMessage error={errors[schema.role.honorific.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.honorific.validators),
                    schema.role.honorific.label
                  )}
                </ControlLabel>
                <Controller
                  key={schema.role.honorific.name}
                  name={schema.role.honorific.name}
                  control={control}
                  rules={isValidators(schema.role.honorific.validators)}
                  defaultValue={honorific}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ width: '100%' }}
                        searchable={true}
                        value={props.value}
                        data={schema.honorificOptions}
                        placeholder={schema.role.honorific.hint}
                        onChange={(value, label) => {
                          setHonorific(value)
                          props.onChange(value)
                          // setValue(schema.role.honorific.name, value)
                          // clearErrors(schema.role.honorific.name)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.role.firstName.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.firstName.validators),
                    schema.role.firstName.label
                  )}
                </ControlLabel>
                <Input
                  name={schema.role.firstName.name}
                  // defaultValue={schema.role.firstName.value}
                  defaultValue={firstName}
                  placeholder={schema.role.firstName.hint || `ระบุ${schema.role.firstName.label}`}
                  inputRef={register(isValidators(schema.role.firstName.validators))}
                  onChange={(value) => setFirstName(value)}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.role.lastName.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.lastName.validators),
                    schema.role.lastName.label
                  )}
                </ControlLabel>
                <Input
                  name={schema.role.lastName.name}
                  // defaultValue={schema.role.lastName.value}
                  defaultValue={lastName}
                  placeholder={schema.role.lastName.hint || `ระบุ${schema.role.lastName.label}`}
                  inputRef={register(isValidators(schema.role.lastName.validators))}
                  onChange={(value) => setLastName(value)}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.role.email.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.email.validators),
                    schema.role.email.label
                  )}
                </ControlLabel>
                <Input
                  name={schema.role.email.name}
                  // defaultValue={schema.role.email.value}
                  defaultValue={email}
                  placeholder={schema.role.email.hint || `ระบุ${schema.role.email.label}`}
                  inputRef={register(isValidators(schema.role.email.validators))}
                  onChange={(value) => setEmail(value)}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8}>
                <ErrorMessage error={errors[schema.role.telephone.name]} />
                <ControlLabel>
                  {isRequiredFiled(
                    isRequired(schema.role.telephone.validators),
                    schema.role.telephone.label
                  )}
                </ControlLabel>
                <Input
                  name={schema.role.telephone.name}
                  // defaultValue={schema.role.telephone.value}
                  defaultValue={telephone}
                  placeholder={schema.role.telephone.hint || `ระบุ${schema.role.telephone.label}`}
                  inputRef={register(isValidators(schema.role.telephone.validators))}
                  onChange={(value) => setTelephone(value)}
                />
              </Col>
            </Row>
            {isSaveError && (
              <Message
                showIcon
                type="error"
                description={`บันทึก${
                  schema.role.buttonText ? schema.role.buttonText : ''
                }ไม่สำเร็จ`}
              />
            )}
            <Row style={{ marginTop: 10 }}>
              <IconButton
                appearance="ghost"
                className={editIndex === -1 ? '' : 'rs-btn-ghost-edit'}
                icon={
                  <Icon
                    appearance="ghost"
                    icon={editIndex === -1 ? 'save' : 'edit'}
                    className={
                      editIndex === -1 ? 'bt-gost-icon-radius' : 'bt-gost-icon-radius-edit'
                    }
                  />
                }
                onClick={(e) => onSubmit()}
                style={{ marginRight: 5 }}
              >
                {`บันทึก${schema.role.buttonText}`}
              </IconButton>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={<Icon className="bt-gost-icon-radius-cancel" icon={'close'} />}
                onClick={(e) => {
                  setIsAdd(false)
                  setIsDeleteFail(false)
                }}
                style={{ marginRight: 5 }}
              >
                {`ยกเลิก${schema.role.buttonText}`}
              </IconButton>
            </Row>
          </FormGroup>
        </Form>
      </Grid>
    )
  }

  return (
    <div className="component-overview">
      <Panel style={{ marginBottom: '20px' }} bodyFill>
        <Panel header="" eventKey={2} shaded>
          {schema.description && <CustomAlertMessageInfo contents={schema.description} />}

          {isAdd ? (
            AddForm()
          ) : (
            <>
              <Row style={{ marginTop: '10px' }}>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                  <div>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                      onClick={onAdd}
                      style={{ marginRight: 5 }}
                    >
                      {'เพิ่ม'}
                      {schema.role.buttonText ? schema.role.buttonText : ''}
                    </IconButton>
                  </div>
                </Col>
              </Row>
            </>
          )}
          <br />
          {schema.descriptionNote && (
            <div style={{ marginBottom: 10 }}>
              <CustomNote data={schema.descriptionNote} />
            </div>
          )}
          {/* <CustomIconMessageInfo contents={schema.role.description} />
          <br /> */}
          {isDeleteFail && (
            <Message
              showIcon
              type="error"
              description={`ลบ ${schema.role.buttonText ? schema.role.buttonText : ''} ไม่สำเร็จ`}
            />
          )}
          <ProjectManageStructureTableForm
            schema={schema.role}
            isEdit={true}
            handleDelete={onDelete}
            handleEdit={handleEdit}
          />

          <br />
          <hr />
          <ProjectManageAttachWidget
            onDownload={onDownload}
            onPreview={onPreview}
            schema={schema.attachFiles}
          ></ProjectManageAttachWidget>
        </Panel>
      </Panel>
    </div>
  )
}
